export const apiClientFieldLabelClassName = 'block h-f2';
